import { render, staticRenderFns } from "./PpomStats.vue?vue&type=template&id=308db9d8&scoped=true"
import script from "./PpomStats.vue?vue&type=script&lang=js"
export * from "./PpomStats.vue?vue&type=script&lang=js"
import style0 from "./PpomStats.vue?vue&type=style&index=0&id=308db9d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308db9d8",
  null
  
)

export default component.exports